import { motion } from 'framer-motion';
import { Bug } from 'lucide-react';

export function DiseaseHistoryItem({ detection, onClick }) {
  return (
    <motion.div
      whileHover={{ scale: 1.02 }}
      className="border rounded-lg p-4 hover:bg-gray-50 transition-colors cursor-pointer"
      onClick={() => onClick(detection)}
    >
      <div className="flex items-start gap-3">
        <img
          src={detection.imageUrl}
          alt="Plant"
          className="w-16 h-16 rounded-lg object-cover"
        />
        <div className="flex-1">
          <div className="flex flex-col gap-1">
            <span className="font-medium text-gray-900">
              {detection.plantName}
            </span>
            <span
              className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium w-fit ${
                detection.status === 'healthy'
                  ? 'bg-green-100 text-green-800'
                  : detection.status === 'tentative'
                    ? 'bg-yellow-100 text-yellow-800'
                    : 'bg-red-100 text-red-800'
              }`}
            >
              {detection.status === 'healthy'
                ? 'Healthy'
                : detection.status === 'tentative'
                  ? 'Tentative'
                  : 'Disease Detected'}
            </span>
          </div>
          <p className="text-sm text-gray-500 mt-1">
            {new Date(detection.createdAt?.toDate()).toLocaleDateString()}
          </p>
        </div>
        <Bug className="w-5 h-5 text-amber-600" />
      </div>
    </motion.div>
  );
}
